import store from "../../store/index";
import apiOffice from "../axios/apiOffice";

class UserService {
  static async getPersonByCuil(cuil) {
    try {
      const cidiCookie = store.state.CidiCookie; // Access state from Vuex store
      const data = {
        cuil,
        cidi: cidiCookie,
      };
      const response = await apiOffice.post(`/oficina/users/person-by-cuil`, data);
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting person:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async saveUser(body) {
    try {
      const response = await apiOffice.post(`/oficina/users/save`, body);
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting person:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async isEmailUsed(emaila) {
    try {
      const body = { email: emaila };
      const response = await apiOffice.post(`/oficina/users/email-used`, body);
      console.log("response ", response)
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting person:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getUserById(id) {
    try {
      const response = await apiOffice.get(`/oficina/user-by-id/${id}`);
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting person:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getUsers(page = 1, size = 5) {
    try {
      const response = await apiOffice.get(`/oficina/users?page=${page}&size=${size}`);
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting person:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getAllUsers() {
    try {
      const response = await apiOffice.get(`/oficina/users/all`);
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting person:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getUsersFiltered(filters, page = 1, size = 5) {
    try {
      const body = { conditions: filters }
      const response = await apiOffice.post(`/oficina/users/filter?page=${page}&size=${size}`, body);
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting availables times:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getUsersByQuery(query) {
    try {
      const response = await apiOffice.post(`/oficina/users/query`, { queryName: query });
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
    } catch (error) {
      console.error("Error getting users:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

export default UserService;
